module.exports = __webpack_public_path__ + "img/logoDark.3af69449.svg";